/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                from '@/util/i.command';
import {FileBrowserWindow}       from '@/screens/ide/file.browser.window';
import {Logger}                  from '@/util/logger';

/**
 *
 * @class FBNavCommand
 *
 * @brief reversible navigation in the file browser
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2020
 *
 */
export class FBNavCommand implements ICommand {

  private newValue: string           = null;
  private oldValue: string           = null;
  private browser: FileBrowserWindow = null;

  constructor(oldValue: string, newValue: string, browser: FileBrowserWindow) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.browser  = browser;
  }

  /** effect the command */
  execute() {

    Logger.debug('[file:ls] navigating: ', this.newValue);

    /* go to the new location */

    this.browser.ls(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    /* go back to previous location */

    Logger.debug('[file:ls] going back to: ', this.oldValue);

    this.browser.ls(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[file:add] ' + this.oldValue + ' => ' + this.newValue;
  }

}
